import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { useLanguage } from '../../../../contexts/LanguageContext';
import DashboardPanel from './DashboardPanel';
import { ALL_TIME } from '../hooks/useLmsDashboardStats';
import { formatNumber } from '../utils/dashboardUtils';

const STAT_CARDS = [
    { key: 'completedTrainings', field: 'completedTrainingCount', icon: 'pi-verified', color: '#D92D20', background: '#FEE4E2' },
    { key: 'trainingHours', field: 'totalHours', icon: 'pi-clock', color: '#2563EB', background: '#DBEAFE' },
    { key: 'peopleTrained', field: 'totalParticipants', icon: 'pi-users', color: '#16A34A', background: '#DCFCE7' },
    { key: 'dealersTrained', field: 'trainedDealerCount', icon: 'pi-building', color: '#F97316', background: '#FFEDD5' }
];

const StatCard = ({ card, value, isLoading, label, description }) => (
    <div className="h-full flex flex-column align-items-center justify-content-center text-center p-4 gap-2" style={{ border: '1px solid #EAECF0', borderRadius: '0.875rem', backgroundColor: '#FFFFFF' }}>
        <div className="flex align-items-center justify-content-center border-circle mb-2" style={{ width: '4.5rem', height: '4.5rem', backgroundColor: card.background }}>
            <i className={`pi ${card.icon}`} style={{ fontSize: '1.9rem', color: card.color }} />
        </div>
        {isLoading ? <Skeleton width="5rem" height="2.25rem" /> : <span style={{ fontSize: '2.25rem', fontWeight: 800, color: '#101828', lineHeight: 1.1 }}>{value}</span>}
        <span className="font-bold" style={{ color: '#101828', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
            {label}
        </span>
        <span className="text-sm" style={{ color: '#475467' }}>
            {description}
        </span>
    </div>
);

const TrainingPerformance = ({ stats, isLoading, period, setPeriod, years, currentYear }) => {
    const { th, getCurrentLocale } = useLanguage();
    const locale = getCurrentLocale();

    const periodOptions = [...years.map((year) => ({ label: year === currentYear ? th('lmsDashboard.performance.thisYear', { year }) : String(year), value: year })), { label: th('lmsDashboard.performance.allTime'), value: ALL_TIME }];

    const periodTemplate = (option) =>
        option ? (
            <span className="flex align-items-center gap-2">
                <i className="pi pi-calendar" />
                {option.label}
            </span>
        ) : null;

    return (
        <DashboardPanel
            title={th('lmsDashboard.performance.title')}
            action={<Dropdown value={period} options={periodOptions} onChange={(e) => setPeriod(e.value)} valueTemplate={periodTemplate} className="border-round-lg" style={{ minWidth: '12rem' }} />}
        >
            <div className="grid flex-grow-1">
                {STAT_CARDS.map((card) => (
                    <div key={card.key} className="col-12 sm:col-6">
                        <StatCard card={card} isLoading={isLoading} value={formatNumber(stats?.[card.field] ?? 0, locale)} label={th(`lmsDashboard.performance.${card.key}`)} description={th(`lmsDashboard.performance.${card.key}Desc`)} />
                    </div>
                ))}
            </div>
        </DashboardPanel>
    );
};

export default TrainingPerformance;
